import React, { useState, useEffect, useContext } from 'react';
import * as Sentry from '@sentry/react';

import { Route, Routes, useNavigate } from 'react-router-dom';
import { GuestDocumentDetails } from './GuestDocumentDetails';
import { GuestDocumentList } from './GuestDocumentList';

interface Props {}

export const GuestDocuments = (props: Props) => {
	return (
		<Routes location={location}>
			<Route path={':docID/*'} element={<GuestDocumentDetails />} />
			<Route index element={<GuestDocumentList />} />
		</Routes>
	);
};
